"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("@emotion/react");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var react_components_1 = require("@gamepark/react-components");
var rules_api_1 = require("@gamepark/rules-api");
var moment_1 = __importDefault(require("moment"));
var react_2 = require("react");
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var GameProvider_1 = require("../GameProvider");
var Menu_1 = require("../Menu");
var EjectPlayer_1 = require("./EjectPlayer");
var useOpponentWithMaxTime_1 = __importDefault(require("./useOpponentWithMaxTime"));
function EjectPlayerDialog(_a) {
    var _b;
    var close = _a.close, props = __rest(_a, ["close"]);
    var t = react_i18next_1.useTranslation().t;
    var maxExceedTime = react_redux_1.useSelector(function (state) { var _a, _b; return (_b = (_a = state.options) === null || _a === void 0 ? void 0 : _a.maxExceedTime) !== null && _b !== void 0 ? _b : 60000; });
    var opponentWithNegativeTime = useOpponentWithMaxTime_1.default(0);
    var opponentThatCanBeEjected = useOpponentWithMaxTime_1.default();
    var dispatch = react_redux_1.useDispatch();
    var optionsSpec = (_b = react_2.useContext(GameProvider_1.GameContext)) === null || _b === void 0 ? void 0 : _b.optionsSpec;
    react_2.useEffect(function () {
        if (!opponentWithNegativeTime) {
            close();
        }
    }, [opponentWithNegativeTime]);
    if (!opponentWithNegativeTime)
        return null;
    var opponentName = opponentWithNegativeTime.name || rules_api_1.getFallbackPlayerName(opponentWithNegativeTime.id, t, optionsSpec);
    return (jsx_runtime_1.jsxs(react_components_1.Dialog, __assign({ onBackdropClick: close, css: Menu_1.menuDialogCss }, props, { children: [jsx_runtime_1.jsx("h2", { children: t('eject.dialog.p1', { player: opponentName }) }, void 0),
            !opponentThatCanBeEjected ?
                jsx_runtime_1.jsx("p", { children: t('eject.dialog.p2', { duration: moment_1.default.duration(maxExceedTime).humanize() }) }, void 0) :
                jsx_runtime_1.jsx("p", { children: t('eject.dialog.p3') }, void 0),
            jsx_runtime_1.jsxs("div", __assign({ css: buttonLineCss }, { children: [jsx_runtime_1.jsx("button", __assign({ css: [Menu_1.menuButtonCss, inDialogButton], onClick: close }, { children: t('Close') }), void 0),
                    opponentThatCanBeEjected &&
                        jsx_runtime_1.jsxs("button", __assign({ css: [Menu_1.menuButtonCss, buttonCss, inDialogButton], onClick: function () { return dispatch(EjectPlayer_1.ejectPlayerAction(opponentThatCanBeEjected.id)); } }, { children: [jsx_runtime_1.jsx(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faUserSlash }, void 0), t('Eject {player}', { player: opponentName })] }), void 0)] }), void 0)] }), void 0));
}
exports.default = EjectPlayerDialog;
var buttonCss = react_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: darkred;\n  border-color: darkred;\n\n  &:focus, &:hover {\n    background: #ffd7d7\n  }\n\n  &:active {\n    background: #ffbebe\n  }\n"], ["\n  color: darkred;\n  border-color: darkred;\n\n  &:focus, &:hover {\n    background: #ffd7d7\n  }\n\n  &:active {\n    background: #ffbebe\n  }\n"])));
var buttonLineCss = react_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 1em;\n  display: flex;\n  justify-content: space-between;\n"], ["\n  margin-top: 1em;\n  display: flex;\n  justify-content: space-between;\n"])));
var inDialogButton = react_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 0;\n"], ["\n  margin: 0;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=EjectPlayerDialog.js.map